import { Dispatch, SetStateAction, useEffect, useState } from 'react';

function useDeferredState<S>(deferredState: S | (() => S)): [S, Dispatch<SetStateAction<S>>] {
  const [state, setState] = useState(deferredState);

  useEffect(() => {
    let nextState: S | (() => S) = deferredState;
    if (deferredState instanceof Function) {
      nextState = deferredState();
    }

    if (nextState !== state) {
      setState(nextState);
    }
  }, [deferredState, setState]); // eslint-disable-line react-hooks/exhaustive-deps

  return [state, setState];
}

export default useDeferredState;
